import React, { useState } from 'react';
import axios from 'axios';
import '../assets/SiteVisitForm.css';

export default function SiteVisitForm() {
    const [formData, setFormData] = useState({
        customer_name: '',
        phone_number: '',
        site_visit_date: '',
        project_name: '',
        outcome: '',
        assigned_executive: '',
        telecaller_name: '',
        customer_reference: '',
        notes: '',
        booked_phase: '',
        booked_plot_number: '',
        booking_amount: '',
    });

    const [successMsg, setSuccessMsg] = useState('');
    const [errorMsg, setErrorMsg] = useState('');

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Basic Validation
        if (
            !formData.customer_name || !formData.phone_number ||
            !formData.site_visit_date || !formData.project_name || !formData.outcome ||
            !formData.assigned_executive || !formData.telecaller_name ||
            !formData.customer_reference
        ) {
            setErrorMsg('Please fill all required fields.');
            return;
        }

        try {
            const res = await axios.post('https://www.samriddhidevelopers.in/backend/siteVisit.php', formData);
            if (res.data.message) {
                setSuccessMsg(res.data.message);
                setFormData({
                    customer_name: '',
                    phone_number: '',
                    site_visit_date: '',
                    project_name: '',
                    outcome: '',
                    assigned_executive: '',
                    telecaller_name: '',
                    customer_reference: '',
                    notes: '',
                    booked_phase: '',
                    booked_plot_number: '',
                    booking_amount: '',
                });
                setTimeout(() => setSuccessMsg(''), 4000);
            }
        } catch (err) {
            console.error('Submission error:', err);
            setErrorMsg('Something went wrong. Try again.');
        }
    };

    return (
        <div className="site-visit-form-container">
            <h2 className="site-visit-form-title">Customer Site Visit</h2>


            <form onSubmit={handleSubmit} className="site-visit-form">
                <div className="site-visit-form-group">
                    <label>Customer Name *</label>
                    <input type="text" name="customer_name" value={formData.customer_name} onChange={handleChange} required />
                </div>

                <div className="site-visit-form-group">
                    <label>Phone Number *</label>
                    <input type="tel" name="phone_number" value={formData.phone_number} onChange={handleChange} required />
                </div>

                <div className="site-visit-form-group">
                    <label>Site Visit Date *</label>
                    <input type="date" name="site_visit_date" value={formData.site_visit_date} onChange={handleChange} required />
                </div>

                <div className="site-visit-form-group">
                    <label>Project Name *</label>
                    <select name="project_name" value={formData.project_name} onChange={handleChange} required>
                        <option value="">Select</option>
                        <option value="Lonavalley">Lonavalley</option>
                        <option value="PMAY-dhayari">Dhayari-PMAY</option>
                        <option value="PMAY-kirkatwadi">Kirkatwadi-PMAY</option>
                        <option value="Waterscape">Waterscape</option>
                        <option value="Velhe">Velhe-swaraj Toran</option>
                        <option value="Blue Horizon">Blue Horizon</option>
                        <option value="Kokan Samriddhi">Kokan Samriddhi</option>
                    </select>
                </div>

                <div className="site-visit-form-group">
                    <label>Outcome of Visit *</label>
                    <select name="outcome" value={formData.outcome} onChange={handleChange} required>
                        <option value="">Select</option>
                        <option value="Positive">Positive</option>
                        <option value="Booking_done">Booked a Plot</option>
                        <option value="Need Follow-up">Need Follow-up</option>
                        <option value="Not Interested">Not Interested</option>
                    </select>
                </div>

                {formData.outcome === 'Booking_done' && (
                    <>
                        <div className="site-visit-form-group">
                            <label>Booked Plot Phase *</label>
                            <input type="text" name="booked_phase" value={formData.booked_phase} onChange={handleChange} placeholder="Phase 1 / Phase 2 etc." required />
                        </div>

                        <div className="site-visit-form-group">
                            <label>Booked Plot Number *</label>
                            <input type="text" name="booked_plot_number" value={formData.booked_plot_number} onChange={handleChange} placeholder="e.g. P-17" required />
                        </div>

                        <div className="site-visit-form-group">
                            <label>Booking Amount Given (₹) *</label>
                            <input type="number" name="booking_amount" value={formData.booking_amount} onChange={handleChange} placeholder="Amount in INR" required />
                        </div>
                    </>
                )}

                <div className="site-visit-form-group">
                    <label>Assigned Sales Executive *</label>
                    <select name="assigned_executive" value={formData.assigned_executive} onChange={handleChange} required>
                        <option value="">Select</option>
                        <option value="Ajay Kambale">Ajay Kambale</option>
                        <option value="Namdev Patil">Namdev Patil</option>
                        <option value="Sagar">Sagar</option>
                        <option value="Yogesh">Yogesh</option>
                        <option value="Sopan">Sopan</option>
                        <option value="Sopan">Amrit Kantak</option>

                    </select>
                </div>

                <div className="site-visit-form-group">
                    <label>Called By Telecaller *</label>
                    <select name="telecaller_name" value={formData.telecaller_name} onChange={handleChange} required>
                        <option value="">Select</option>
                        <option value="Gauri">Gauri</option>
                        <option value="Ranjana">Ranjana</option>
                        <option value="Smita">Smita</option>
                        <option value="Shalini">Shalini</option>
                        <option value="Sarika">Sarika</option>
                        <option value="Shravani">Shravani</option>
                        <option value="Rutuja">Rutuja</option>
                        <option value="Sayali">Sayali</option>
                        <option value="Vaishali">Vaishali</option>
                        <option value="Shubhangi">Shubhangi</option>
                        <option value="pooja">Pooja</option>
                        <option value="Priti">Priti</option>
                        <option value="Sonali">Sonali</option>
                        <option value="Self">Self</option>
                    </select>
                </div>

                <div className="site-visit-form-group">
                    <label>Customer Reference *</label>
                    <select name="customer_reference" value={formData.customer_reference} onChange={handleChange} required>
                        <option value="">Select</option>
                        <option value="Facebook">Facebook</option>
                        <option value="Expo">Expo</option>
                        <option value="Paper Ad">Paper Ad</option>
                        <option value="Personal Lead">Personal Lead</option>
                        <option value="LinkedIn">LinkedIn</option>
                        <option value="MagicBricks">MagicBricks</option>
                        <option value="99acres">99acres</option>
                        <option value="Other">Other</option>
                    </select>
                </div>

                <div className="site-visit-form-group">
                    <label>Visit Notes</label>
                    <textarea name="notes" value={formData.notes} onChange={handleChange} rows="4" placeholder="Agreement Expected within what time..." />
                </div>

                <div className="site-visit-form-submit">
                    <button type="submit">Submit Visit</button>
                </div>

                {errorMsg && <p className="site-visit-error-message">{errorMsg}</p>}
                {successMsg && <p className="site-visit-success-message">{successMsg}</p>}

            </form>
        </div>
    );
}
